module.exports = __webpack_public_path__ + "static/img/xjht_sw_bg.cbc721f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xjht_sw_bg.png
// module id = dEfd
// module chunks = 489